/** @jsx jsx */
import { any, string } from 'prop-types'
import { jsx, Flex } from 'theme-ui'
import NavList from './NavList'
import CustomSearchBar from '../common/CustomSearchBar'
import { useState } from 'react'
import { useLocation } from '@reach/router'
import { BrandLogoDesktop } from '../../icons/index'
import { Link as GatsbyLink } from 'gatsby'

const DesktopNavigationMenu = ({ navList }) => {
  const location = useLocation()
  const showSearchBar = !location.pathname.startsWith('/app/ResourceSearch')
  const [setSearchTerm] = useState('')
  return (
    <Flex
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        zIndex: 110,
        backgroundColor: 'var(--theme-ui-colors-forest, #304a3d)',
        boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
        flexGrow: 1,
        alignItems: 'center',
        justifyContent: 'space-flex-start',
        px: 4,
        height: '64px',
      }}
    >
      <Flex
        sx={{
          height: 'auto',
          display: 'block',
          flexShrink: 0,
          flexGrow: 0,
        }}
      >
        <GatsbyLink to="/" aria-label="Home">
          <BrandLogoDesktop />
        </GatsbyLink>
      </Flex>

      <Flex sx={{ flex: 1, justifyContent: 'center', minWidth: 'auto' }}>
        <GatsbyLink
          to="/app/brand-studio-events"
          data-automation-id="register-live-event-link"
          sx={{
            display: 'inline-flex',
            textDecoration: 'none',
            cursor: 'pointer',
            minWidth: 180,
            width: ['auto', 'auto', 300],
            backgroundColor: 'citron',
            boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.75)',
            padding: ['8px', '8px 16px', '12px 16px'],
            minHeight: '44px',
            color: 'black',
            fontSize: ['14px', '16px'],
            textAlign: 'center',
            lineHeight: 1,
            margin: ['0px 20px', 0, '0 0 0 160px'],
            ':hover': { backgroundColor: 'citronHover' },
            whiteSpace: 'nowrap',
            justifyContent: 'center',
            alignItems: 'center',
            overflow: 'hidden',
          }}
        >
          Register for a Live Event
        </GatsbyLink>
      </Flex>
      {showSearchBar && (
        <Flex
          sx={{
            ml: 4,
            alignItems: 'center',
            height: '38px',
            minWidth: 320,
            maxWidth: 400,
            flex: '0 0 auto',
          }}
        >
          <CustomSearchBar
            setSearchTerm={setSearchTerm}
            searchRedirect={true}
            placeholderText={'Search all Resources'}
          />
        </Flex>
      )}
      <NavList navList={navList} />
    </Flex>
  )
}

DesktopNavigationMenu.propTypes = {
  userInitials: string,
  navList: any.isRequired,
}

export default DesktopNavigationMenu
/**Added sticky nav */
